import React from "react";
import './styles.css';

export const EscritorioContent = () => {
    return(
    <div id="escritorio" className="conteudo">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-10 text-center">
                    <p>
                        Na Virtù, cada linha desenhada e cada plano concebido não são apenas elementos de arquitetura; são a manifestação de valores e compromissos que nos definem.
                    </p>
                    <p>
                        Cada projeto é um diálogo contínuo com nossos clientes, onde suas aspirações e sonhos são a essência do nosso universo criativo.
                    </p>
                    <p>
                        Nossa trajetória é marcada pela paixão por inovação. Na Virtù, arquitetura não é apenas sobre edifícios; é sobre criar legados que ecoam nossos valores mais profundos e compromissos com você.
                    </p>
                </div>
            </div>
        </div>
    </div>
    );
};